import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// ArcElement é obrigatório para Pie/Doughnut no Chart.js v4 — sem isso o gráfico
// lança erro silencioso e o canvas fica vazio, causando altura absurda no card.
ChartJS.register(ArcElement, Tooltip, Legend);

// Chart.js v4 não fornece cores padrão para datasets de Pie — sem backgroundColor
// explícito os segmentos ficam transparentes (invisíveis).
const DEFAULT_COLORS = [
   "#4e73df", "#1cc88a", "#36b9cc", "#f6c23e", "#e74a3b",
   "#fd7e14", "#6f42c1", "#20c997", "#d63384", "#0dcaf0",
];

const PieChart = (props) => {

   const { height, width, data, labels, backgroundColors, hoverBackgroundColors } = props;

   const resolvedColors = backgroundColors || DEFAULT_COLORS.slice(0, (data || []).length);
   const resolvedHoverColors = hoverBackgroundColors || resolvedColors.map(c => c + "cc");

   const graphicData = {
      datasets: [
         {
            data: data,
            borderWidth: 0,
            backgroundColor: resolvedColors,
            hoverBackgroundColor: resolvedHoverColors,
         },
      ],
      labels: labels,
   };

   const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
         legend: {
            display: true,
            position: "bottom",
         },
      },
   };

   // Container com dimensões explícitas: com maintainAspectRatio=false e responsive=true
   // o canvas preenche o pai — sem altura definida no pai ele cresce indefinidamente.
   return (
      <div style={{ position: "relative", width: width || 200, height: height || 200, margin: "0 auto" }}>
         <Pie data={graphicData} options={options} />
      </div>
   );
};

export default PieChart;
